import { render } from "./PackageChargesPage.vue?vue&type=template&id=c1cf1e54&scoped=true"
import script from "./PackageChargesPage.vue?vue&type=script&lang=js"
export * from "./PackageChargesPage.vue?vue&type=script&lang=js"

import "./PackageChargesPage.vue?vue&type=style&index=0&id=c1cf1e54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1cf1e54"]])

export default __exports__